import React from "react";
import { useTranslation } from "react-i18next";

const YesNoQuestion = ({ selectedOption, onOptionChange }) => {
  const { t } = useTranslation();

  return (
    <div className="space-y-2">
      <div
        className="bg-white rounded-full p-3 flex items-center cursor-pointer"
        onClick={() => onOptionChange("Yes")}
      >
        <div className="flex items-center">
          <div
            className={`w-5 h-5 rounded-full border ${
              selectedOption === "Yes" ? "border-indigo-600" : "border-gray-300"
            } flex items-center justify-center`}
          >
            {selectedOption === "Yes" && (
              <div className="w-3 h-3 rounded-full bg-indigo-600"></div>
            )}
          </div>
          <span className="ml-3 text-gray-700">{t("base.yes")}</span>
        </div>
      </div>

      <div
        className="bg-white rounded-full p-3 flex items-center cursor-pointer"
        onClick={() => onOptionChange("No")}
      >
        <div className="flex items-center">
          <div
            className={`w-5 h-5 rounded-full border ${
              selectedOption === "No" ? "border-indigo-600" : "border-gray-300"
            } flex items-center justify-center`}
          >
            {selectedOption === "No" && (
              <div className="w-3 h-3 rounded-full bg-indigo-600"></div>
            )}
          </div>
          <span className="ml-3 text-gray-700">{t("base.no")}</span>
        </div>
      </div>
    </div>
  );
};

export default YesNoQuestion;
